// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-routine-dialog-content {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}

.create-routine-dialog-content .routine-types-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
  margin-top: 16px;
}

/* Mobile responsive */
@media (max-width: 768px) {
  .create-routine-dialog-content {
    padding: 0px;
  }
  
  .create-routine-dialog-content .routine-types-grid {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/dialogs/CreateRoutineDialog.css"],"names":[],"mappings":"AAAA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;EACd;;EAEA;IACE,4DAA4D;IAC5D,SAAS;EACX;AACF","sourcesContent":[".create-routine-dialog-content {\n  flex: 1;\n  overflow-y: auto;\n  min-height: 0;\n}\n\n.create-routine-dialog-content .routine-types-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 16px;\n  margin-top: 16px;\n}\n\n/* Mobile responsive */\n@media (max-width: 768px) {\n  .create-routine-dialog-content {\n    padding: 0px;\n  }\n  \n  .create-routine-dialog-content .routine-types-grid {\n    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n    gap: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
